<template>
  <div class="onboarding__container" style="justify-content: center; min-height: 80vh">
    <span class="onboarding__eyebrow">
      <i class="fas fa-rocket"></i> Setup
    </span>
    <h1 class="onboarding__step-title" style="font-size: 34px">
      Hi {{ current_user.username }}
    </h1>
    <p class="onboarding__step-lede">
      Let's get Carl-bot configured for your server. It takes about a minute, and
      you can change anything later from the dashboard.
    </p>
    <div style="display: flex; gap: 12px; align-items: center; margin-top: 14px">
      <button @click="startOnboarding" class="saucy-btn">
        Get started <i class="fas fa-arrow-right" style="font-size: 11px"></i>
      </button>
    </div>
    <button class="skip-btn" @click="skipOnboarding">Skip</button>
  </div>
</template>

<script>
export default {
  name: "OnboardingLanding",
  methods: {
    skipOnboarding() {
      const guild_id = this.$route.params.guild_id;
      this.$router.push(`/dashboard/${guild_id}`);
    },
    startOnboarding() {
      const guild_id = this.$route.params.guild_id;
      this.$router.push(`/onboarding/${guild_id}/general`);
    },
  },
  computed: {
    current_user() {
      return this.$store.state.discord_user || {};
    },
  },
};
</script>
